export default function verifyLogin(history) {
    if (!localStorage.getItem('funleagueToken')) {
        history.push('/login');
    }
}